<template>
<div :class="showError?'ivu-form-item-error':''" >
<input class="ivu-input"
    v-model="phoneStr"
    :placeholder="placeholder"
    :disabled="disabled"
    :maxlength="maxlength"
    :readonly="readonly"
    autocomplete="off"
    @blur="onBlur"
    style="width:100%"
    >
    <div v-show="showError" class="ivu-form-item-error-tip">{{errorMsg}}</div>
</div>
</template>
<script>
export default {
  name: "InputPhone",
  props: {
    value: {
      type: [Number, String]
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxlength: {
      type: Number,
      default: 30
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      phoneStr:"",
      errorMsg:"",
      showError:false
    };
  },
  created() {
  },
  watch: { 
    value(newValue,oldValue){
      this.phoneStr=newValue
    }
  },
  methods: {
    onBlur() { 
      let value=this.phoneStr
      if(value.trim()==""){
        this.showError=true;
        this.errorMsg="电话号码不能为空"
      }else if(!/^[\d\-]+$/.test(value)){
        this.showError=true;
        this.errorMsg="请输入11位电话号码或者座机号码"
      }else{
        this.errorMsg=""
        this.showError=false
        this.$emit('input', value)
      }
    }
  }
};
</script>
>


// WEBPACK FOOTER //
// src/components/common/inputPhone.vue